<template>
<div>
	<!--<section class="padd-40">
		<div class="container">
			<div class="job-verticle-list">
				<div class="vertical-job-card">
					<div class="">
						<h3><a href="job-detail.html">{{ $t('contact.er') }}</a></h3>
						<h4>{{ $t('contact.sh') }}</h4>
					</div>
					<div class="vertical-job-body">
						<div class="row">
							<div class="col-md-12 col-sm-12">
								<ul class="can-skils">
									<li><i class="ti-location-pin"></i> {{ $t('contact.addr') }}</li>
									<li><i class="ti-mobile"></i> +86 21 6288 1891</li>
									<li><i class="ti-envelope"></i> info@element-resources.com</li>
								</ul>
							</div>
							<div class="col-md-12 col-sm-12">
								<div class="blog-footer-social">
									<ul class="list-inline social">
										<li><a href="https://weibo.com/elementresources?refer_flag=1001030201_&is_hot=1" target="_blank"><i class="fa fa-weibo weibo-cl"></i></a></li>
										<li><a href="https://www.linkedin.com/company/element-resources/" target="_blank"><i class="fa fa-linkedin linkedin-cl"></i></a></li>
										<li><a href="javascript:void(0)"  data-toggle="modal" data-target="#followus"><i class="fa fa-wechat wechat-cl"></i></a></li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					
				</div>


			</div>
		</div>
	</section>-->

	<section class="padd-40">
		<div class="container">
			<div class="col-md-12 col-sm-12 translateY-60">
				<div class="col-md-6 col-sm-6" @click="changeMap('sh')">
					<div class="detail-wrapper text-center padd-top-40 mrg-bot-10 padd-bot-40 light-bg">
						<i class="theme-cl font-30 ti-location-pin"></i>
						<h4>{{ $t('contact.sh') }}</h4>
						{{ $t('contact.addr') }}<br>
						<i class="ti-mobile"></i> +86 21 6288 1891
					</div>
				</div>
				<div class="col-md-6 col-sm-6" @click="changeMap('bj')">
					<div class="detail-wrapper text-center padd-top-40 mrg-bot-10 padd-bot-40 light-bg">
						<i class="theme-cl font-30 ti-location-pin"></i>
						<h4>{{ $t('contact.bj') }}</h4>
						{{ $t('contact.addr-bj') }}<br>
						<i class="ti-mobile"></i> +86 10 6521 1577
					</div>
				</div>
				<div class="col-md-6 col-sm-6" @click="changeMap('nj')">
					<div class="detail-wrapper text-center padd-top-40 mrg-bot-10 padd-bot-40 light-bg">
						<i class="theme-cl font-30 ti-location-pin"></i>
						<h4>{{ $t('contact.nj') }}</h4>
						{{ $t('contact.addr-nj') }}<br>
						<i class="ti-mobile"></i> +86 25 8470 7303
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="padd-top-20">
		<div class="container">

			<div class="col-md-6 col-sm-6">
				<h3>{{ $t('contact.message') }}</h3>
				<form>
					<div class="form-group">
						<label>{{ $t('contact.name') }}:</label>
						<input name="name" v-validate="'required'" type="text" class="form-control" :placeholder="$t('contact.name') + ' *'" v-model="formData.name" />
						<span>{{ errors.first('name') }}</span>
					</div>
					<div class="form-group">
						<label>{{ $t('contact.email') }}:</label>
						<input name="email" v-validate="'email'" type="email" class="form-control" :placeholder="$t('contact.email')" v-model="formData.email" />
						<span>{{ errors.first('email') }}</span>
					</div>
					<div class="form-group">
						<label>{{ $t('contact.content') }}:</label>
						<textarea name="message" v-validate="'required'" class="form-control height-120" :placeholder="$t('contact.content') + ' *'" v-model="formData.message"></textarea>
						<span>{{ errors.first('message') }}</span>
					</div>
					<div class="form-group">
						<button class="btn theme-btn" name="submit" @click.prevent="sendMessage">{{ $t('contact.submit') }}</button>
					</div>
				</form>
			</div>
			<div class="col-md-6 col-sm-6">
				<h3>{{ $t('contact.map') }}</h3>
				<Map :longitude="longitude" :latitude="latitude" />
			</div>
		</div>
	</section>
</div>
</template>
<script>
import Map from '@/components/Map.vue'
export default {
  name: 'ContactInfo',
  data: () => ({
	formData: {
	  'name': '',
	  'email': '',
	  'message': ''
	},
	longitude: 121.4411973,
	latitude: 31.2224423
  }),
  components: {
  	Map
  },
  methods: {
    changeMap: function(m) {
      if (m == 'sh') {
        this.longitude = 121.4411973
        this.latitude = 31.2224423
      } else if (m == 'bj') {
        this.longitude = 116.470277
        this.latitude = 39.913005
      } else {
      	this.longitude = 118.7916
        this.latitude = 32.057147
      }
    },
    sendMessage: function() {
      this.$validator.validate().then(result => {
        if (!result) {
          // do stuff if not valid.
          this.$message({
	          message: this.$t('contact.invalid'),
	          type: 'error'
	        })
        } else {
          this.$message({
	          message: this.$t('contact.sucess'),
	          type: 'success'
	        })
        }
      })
    },
    resetForm: function() {
      this.formData = {
		  'name': '',
		  'email': '',
		  'message': ''
		}
    }
  }
}
</script>